import { AuthData } from "api/resources/auth/types"
import { AuthManager } from "features/Authentication/AuthManager"
import { importantSearchParams, Platforms, USER_TYPE } from "utils/constants"

export const getCurrentPlatform = (): Platforms => {
  const search = new URLSearchParams(window.location.search)
  const schoolAuth = AuthManager.getPlatformAuth(Platforms.school)
  const recruiterAuth = AuthManager.getPlatformAuth(Platforms.recruiter)
  const centreAuth = AuthManager.getPlatformAuth(Platforms.centerAdmin)

  const isSchool =
    search.get(importantSearchParams.platformOverride) === Platforms.school &&
    Boolean(schoolAuth)

  if (isSchool) return Platforms.school

  const isRecruiter =
    search.get(importantSearchParams.platformOverride) ===
      Platforms.recruiter && Boolean(recruiterAuth)

  if (isRecruiter) return Platforms.recruiter

  const isCentre =
    search.get(importantSearchParams.platformOverride) ===
      Platforms.centerAdmin && Boolean(centreAuth)

  if (isCentre) return Platforms.centerAdmin

  return USER_TYPE
}

export const getCurrentToken = (): AuthData | null => {
  const platform = getCurrentPlatform()

  switch (platform) {
    case Platforms.school: {
      return AuthManager.getPlatformAuth(platform)
    }
    case Platforms.centerAdmin: {
      return AuthManager.getPlatformAuth(platform)
    }
    case Platforms.recruiter: {
      return AuthManager.getPlatformAuth(platform)
    }
    case Platforms.student: {
      return AuthManager.getPlatformAuth()
    }
  }

  throw new Error("platform not handled")
}

export const detectPlatformFromPath = (): Platforms => {
  const pathname = window.location.pathname
  if (pathname.startsWith("/centre")) return Platforms.centerAdmin
  if (pathname.startsWith("/school")) return Platforms.school
  if (pathname.startsWith("/recruiter")) return Platforms.recruiter
  return Platforms.student
}
